import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

import { StorageService } from '../services/storage.service';
import { AuthConfigService } from './auth-config.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    public oAuthService: OAuthService,
    public router: Router,
    public storageService: StorageService,
    private authConfigService: AuthConfigService
  ) {}

  canActivate(): boolean {
    if (!this.oAuthService.hasValidAccessToken() || !this.oAuthService.hasValidIdToken()) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
